import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { Order, OrderStatus } from "@/redux/services/order/order.type";
import { Roles } from "@/redux/services/user/user.type";
import { cn, getOrderStatusText } from "@/lib/utils";
import OrderCard from "./OrderCard";

interface Props {
  status: OrderStatus;
  orders: Order[];
  searchOrderNumber: string;
  userRole?: Roles;
  onModalOpen?: () => void;
  onModalClose?: () => void;
}

const OrderStatusGroup: React.FC<Props> = ({
  status,
  orders,
  searchOrderNumber,
  userRole,
  onModalOpen,
  onModalClose,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <section className="space-y-3">
      <button
        type="button"
        onClick={() => setIsCollapsed((v) => !v)}
        className="flex items-center gap-2 w-full group"
        aria-expanded={!isCollapsed}
      >
        <ChevronDown
          className={cn(
            "h-4 w-4 text-muted-foreground transition-transform",
            isCollapsed && "-rotate-90"
          )}
        />
        <h3 className="text-sm font-semibold text-card-foreground">
          {getOrderStatusText(status, userRole)}
        </h3>
        <span className="text-xs font-medium text-muted-foreground bg-muted px-2 py-0.5 rounded-full">
          {orders.length}
        </span>
        <span className="flex-1 border-b border-border ml-2" />
      </button>

      {!isCollapsed && (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          {orders.map((order) => (
            <OrderCard
              key={order.id}
              order={order}
              searchOrderNumber={searchOrderNumber}
              onModalOpen={onModalOpen}
              onModalClose={onModalClose}
            />
          ))}
        </div>
      )}
    </section>
  );
};

export default OrderStatusGroup;
